import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { Authentication } from './authentication';

export const loggedInGuard: CanActivateChildFn = async (childRoute, state) => {
  const router = inject(Router);
  const authentication = inject(Authentication);

  const isAuthenticated = await authentication.isAuthenticatedAsync();
  if (!isAuthenticated) {
    return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
  }

  return true;
};
